module.exports = __webpack_public_path__ + "img/image30.450e934c.png";